<div class="wrapper--iban-form">
  <nx-formfield
    [formGroup]="formGroup"
    nxFloatLabel="auto"
    [ngClass]="{'alternate-input': field.info}"
    [label]="field.title ?? '' | translate"
  >
    <nx-formfield-label>
      {{ field.label | translate }}
      <span *ngIf="field.required">*</span>
    </nx-formfield-label>
    <input
      nxInput
      [required]="field.required || false"
      [type]="'text'"
      nxMask
      nxIbanMask
      [formControlName]="field.name"
    />

    <span nxFormfieldHint *ngIf="field.hint">{{ field.hint | translate }}</span>
    <!--
    {{
      field.maskText || field.mask
        | slice: formGroup.controls[field.name].value?.length || 0
    }} -->

    <app-popover-form
      *ngIf="field.popover"
      [popover]="field.popover"
      (popoverShow)="onPopoverShow($event)"
    ></app-popover-form>

    <nx-error
      nxFormfieldError
      *ngFor="
        let item of (!field.hideErrorBox && formGroup.controls[field.name]?.errors) || {}
          | arrayKeys
      "
    >
      {{
        (field.customErrorLabel && field.customErrorLabel[item]
          ? field.customErrorLabel[item]
          : 'azForm.errors.' + item
        ) | translate: {data: formGroup.controls[field.name].errors?.[item] ?? ''}
      }}
    </nx-error>
  </nx-formfield>
  <div class="wrapper--iban-form--description" *ngIf="field.info">
    <a href="{{ field.link | translate }}" *ngIf="field.link; else plainText">
      <ng-container [ngTemplateOutlet]="plainText"></ng-container>
    </a>

    <ng-template #plainText>
      <span>{{ field.info | translate }}</span>
    </ng-template>
  </div>
</div>
